export const BILLING_DETAIL_FIELDS = [
  'invoice_entity_name',
  'email',
  'region',
  'post_code',
  'country',
];

const normalise = value => (value || '').trim().toLowerCase();

export const pickBillingDetails = entity =>
  BILLING_DETAIL_FIELDS.reduce((details, field) => ({ ...details, [field]: entity?.[field] }), {});

export const usesCompanyBillingDetails = (entity, companyEntity) =>
  !!entity &&
  !!companyEntity &&
  BILLING_DETAIL_FIELDS.every(
    field => normalise(entity[field]) === normalise(companyEntity[field]),
  );

export const hasCompleteBillingDetails = entity =>
  ['invoice_entity_name', 'email', 'region', 'post_code'].every(
    field => normalise(entity?.[field]) !== '',
  );

export const billingAddressLine = entity =>
  [[entity?.region, entity?.post_code].filter(Boolean).join(' '), entity?.country]
    .filter(Boolean)
    .join(', ');

export const billingDetailsStatus = (entity, companyEntity) => {
  if (!entity) return 'unsaved';
  if (!hasCompleteBillingDetails(entity)) return 'missing';
  return usesCompanyBillingDetails(entity, companyEntity) ? 'company' : 'own';
};
